"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const AnalysisIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({ viewBox: "0 0 548 512" }, props),
    react_1.default.createElement("g", null,
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { x: "153.93", y: "206.776", width: "75.209", height: "283.224" }),
            react_1.default.createElement("rect", { x: "282.86", y: "266.541", width: "75.209", height: "223.459" }),
            react_1.default.createElement("rect", { x: "411.791", y: "161.135", width: "75.209", height: "328.865" }),
            react_1.default.createElement("rect", { x: "25", y: "314.393", width: "75.209", height: "175.607" }))),
    react_1.default.createElement("g", null,
        react_1.default.createElement("rect", { x: "331.977", y: "101.561", transform: "matrix(0.7608 -0.649 0.649 0.7608 17.0659 276.838)", width: "104.216", height: "27.414" }),
        react_1.default.createElement("rect", { x: "242.297", y: "105.327", transform: "matrix(0.379 -0.9254 0.9254 0.379 26.4448 325.8407)", width: "27.409", height: "75.779" }),
        react_1.default.createElement("rect", { x: "86.484", y: "140.578", transform: "matrix(0.8605 -0.5095 0.5095 0.8605 -60.6957 86.9297)", width: "83.772", height: "27.411" }),
        react_1.default.createElement("ellipse", { cx: "191.658", cy: "116.865", rx: "37.973", ry: "37.946" }),
        react_1.default.createElement("ellipse", { cx: "65.082", cy: "191.703", rx: "37.973", ry: "37.946" }),
        react_1.default.createElement("ellipse", { cx: "320.342", cy: "169.568", rx: "37.973", ry: "37.946" }),
        react_1.default.createElement("ellipse", { cx: "446.918", cy: "59.946", rx: "37.973", ry: "37.946" }))));
exports.AnalysisIcon = AnalysisIcon;
exports.default = exports.AnalysisIcon;
